import { Mirror } from "../Cartridge"
import { u8 } from "../utils"
import { Mapper } from "./Mapper"

export class Mapper001 extends Mapper {
    private characterBankSelect4Low = 0x00
    private characterBankSelect4High = 0x00
    private characterBankSelect8 = 0x00

    private programBankSelect16Low = 0x00
    private programBankSelect16High = 0x00
    private programBankSelect32 = 0x00

    private loadRegister = 0x00
    private loadRegisterCount = 0x00
    private controlRegister = 0x00

    private mirrorMode = Mirror.Horizontal

    private staticRam = new Uint8Array(32 * 1024)

    override cpuMapRead(address: number): [mappedAddress?: number, data?: number] {
        if (address >= 0x6000 && address <= 0x7fff) {
            return [0xffffffff, this.staticRam[address & 0x1fff]]
        }

        if (address >= 0x8000) {
            if (this.controlRegister & 0b01000) {
                if (address >= 0x8000 && address <= 0xbfff) {
                    return [this.programBankSelect16Low * 0x4000 + (address & 0x3fff)]
                }

                if (address >= 0xc000 && address <= 0xffff) {
                    return [this.programBankSelect16High * 0x4000 + (address & 0x3fff)]
                }
            } else {
                return [this.programBankSelect32 * 0x8000 + (address & 0x7fff)]
            }
        }

        return []
    }

    override cpuMapWrite(address: number, data: number): number | undefined {
        if (address >= 0x6000 && address <= 0x7fff) {
            this.staticRam[address & 0x1fff] = data
            return 0xffffffff
        }

        if (address >= 0x8000) {
            if (data & 0x80) {
                this.loadRegister = 0x00
                this.loadRegisterCount = 0x00
                this.controlRegister |= 0x0c
            } else {
                this.loadRegister >>= 1
                this.loadRegister |= (data & 0x01) << 4
                this.loadRegisterCount = u8(this.loadRegisterCount + 1)

                if (this.loadRegisterCount === 5) {
                    const targetRegister = (address >> 13) & 0x03

                    if (targetRegister === 0x00) {
                        this.controlRegister = this.loadRegister & 0x1f

                        switch (this.controlRegister & 0x03) {
                            case 0:
                                this.mirrorMode = Mirror.OneScreenLow
                                break
                            case 1:
                                this.mirrorMode = Mirror.OneScreenHigh
                                break
                            case 2:
                                this.mirrorMode = Mirror.Vertical
                                break
                            case 3:
                                this.mirrorMode = Mirror.Horizontal
                                break
                        }
                    } else if (targetRegister === 0x01) {
                        if (this.controlRegister & 0b10000) {
                            this.characterBankSelect4Low = this.loadRegister & 0x1f
                        } else {
                            this.characterBankSelect8 = this.loadRegister & 0x1e
                        }
                    } else if (targetRegister === 0x02) {
                        if (this.controlRegister & 0b10000) {
                            this.characterBankSelect4High = this.loadRegister & 0x1f
                        }
                    } else if (targetRegister === 0x03) {
                        const programMode = (this.controlRegister >> 2) & 0x03

                        if (programMode === 0x00 || programMode === 0x01) {
                            this.programBankSelect32 = (this.loadRegister & 0x0e) >> 1
                        } else if (programMode === 2) {
                            this.programBankSelect16Low = 0x00
                            this.programBankSelect16High = this.loadRegister & 0x0f
                        } else if (programMode === 3) {
                            this.programBankSelect16Low = this.loadRegister & 0x0f
                            this.programBankSelect16High = this.programBanks - 1
                        }
                    }

                    this.loadRegister = 0x00
                    this.loadRegisterCount = 0x00
                }
            }

            return 0xffffffff
        }
    }

    override ppuMapRead(address: number): number | undefined {
        if (address < 0x2000) {
            if (this.characterBanks === 0) {
                return address
            } else {
                if (this.controlRegister & 0b10000) {
                    if (address >= 0x0000 && address <= 0x0fff) {
                        return this.characterBankSelect4Low * 0x1000 + (address & 0x0fff)
                    }

                    if (address >= 0x1000 && address <= 0x1fff) {
                        return this.characterBankSelect4High * 0x1000 + (address & 0x0fff)
                    }
                } else {
                    return this.characterBankSelect8 * 0x2000 + (address & 0x1fff)
                }
            }
        }
    }

    override ppuMapWrite(address: number): number | undefined {
        if (address < 0x2000) {
            if (this.characterBanks === 0) {
                return address
            }

            return 0
        }
    }

    override reset(): number | void {
        this.controlRegister = 0x1c
        this.loadRegister = 0x00
        this.loadRegisterCount = 0x00
        this.mirrorMode = Mirror.OneScreenLow

        this.characterBankSelect4Low = 0x00
        this.characterBankSelect4High = 0x00
        this.characterBankSelect8 = 0x00

        this.programBankSelect16Low = 0x00
        this.programBankSelect16High = this.programBanks - 1
        this.programBankSelect32 = 0x00
    }

    override mirror(): Mirror {
        return this.mirrorMode
    }
}
